import qs, { ParsedQs } from 'qs'

export const qsParse = (search: string): ParsedQs =>
  qs.parse(search, { arrayLimit: Infinity }) as ParsedQs
